var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.requireAuth || _vm.isAuth)?_c('div',[_c('router-view')],1):_c('div',{staticClass:"app-root"},[_c('div',[_c('top-header')],1),_c('div',{staticClass:"app-body"},[_c('side-menu',{staticClass:"sidebar"}),_c('div',{staticClass:"main"},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }